import React, { useMemo } from "react";

import type { XYChartZeroLinesType } from "./types";

const XYChartZeroLine = ({
  leftScale,
  rightScale,
  left,
  width,
  marginTop,
  yMax,
}: XYChartZeroLinesType) => {
  const leftY = useMemo(() => {
    const y = leftScale?.(0);

    if (y) {
      return y + marginTop;
    }
  }, [leftScale, marginTop]);

  const rightY = useMemo(() => {
    const y = rightScale?.(0);

    if (y) {
      return y + marginTop;
    }
  }, [rightScale, marginTop]);

  return (
    <>
      {leftY && leftY < yMax ? (
        <line
          x1={left}
          y1={leftY}
          x2={width + left}
          y2={leftY}
          stroke="#82939A"
        />
      ) : null}

      {rightY && rightY < yMax ? (
        <line
          x1={left}
          y1={rightY}
          x2={width + left}
          y2={rightY}
        />
      ) : null}
    </>
  );
};

export default XYChartZeroLine;
